<template>
  <template v-if="isAuthenticated">
    <Navbar />
    <router-view class="app__main" />
    <Notifications />
  </template>
  <div
    v-else
    class="app__auth-loading"
  >
    <Spinner />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Navbar from '@/components/common/Navbar';
import Notifications from '@/components/common/Notifications';
import Spinner from '@/components/common/Spinner';

export default {
  components: {
    Navbar,
    Notifications,
    Spinner,
  },
  setup() {
    const store = useStore();
    const isAuthenticated = computed(() => store.getters.isAuthenticated);

    return {
      isAuthenticated,
    };
  },
};
</script>

<style lang="scss">
.app__main {
  display: flex;
  width: 100%;
  height: calc(100% - #{$navbarHeight});
  position: relative;
}

.app__auth-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
</style>
